import { Col, Row } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AppContext from "../../../context/app/context";
import EndPoints from "../../../services/end-points";
import Form from "../../form-components/from";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";

import PrizeContext from "../../../context/prize/context";
import { IStore } from "../../../models/store/response";
import { addSearchToURL, filtersToQueryString, getFiltersFromURL, getKeywordFromURL } from "../../../utils/helpers/url";
import { useLocation } from "react-router-dom";

interface IProps {}

const PrizeFilter: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { actions, query } = useContext(PrizeContext);
  const { direction } = useContext(AppContext);
  const [store, setSorts] = useState<IStore[]>([]);
  const [storeLoading, setStoreLoading] = useState(true);

  const location = useLocation();
    const [initialValues, setInitialValues] = useState<Record<string, any>>({});
  
    useEffect(() => {
      const filters = getFiltersFromURL();
  
      const initialValuesObj = {};
      filters.forEach((f) => {
        initialValuesObj[f.name] = f.value;
      });
  
      setInitialValues(initialValuesObj);
    }, [location.search]);
  useEffect(() => {
    const getStore = async () => {
      try {
        const { data } = await EndPoints.store.getAllStores({
          light: true,
          perPage: -1,
        });
        setSorts(data.data);
        setStoreLoading(false);
      } catch (error) {
      } finally {
        setStoreLoading(false);
      }
    };
    getStore();
  }, [direction]);

  return (
    <Form
      formId="prize-filter"
      defaultValues={initialValues}
      onSubmit={(data) => {
        const keyword = getKeywordFromURL();
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: query?.perPage,
          keyword: keyword,
          filters: [
            data?.storeId
              ? {
                  name: "storeId",
                  value: data.storeId,
                  operation: "eq",
                }
              : undefined,
          ].filter((f) => f),
        };
        
                const queryString = filtersToQueryString(filter.filters);
                window.history.replaceState(null, "", `?${queryString}`);
                addSearchToURL(keyword);
                actions.setQuery(filter);
      }}
    >
      <Row justify={"start"} gutter={[10, 0]}>
        <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
          <FieldBuilder
            name="storeId"
            label={`${t("store")}`}
            width="large"
            input={{
              type: "select",
              allowSearch: true,
              loading: storeLoading,
              options: store.map((jop, index) => {
                return {
                  label: jop.name,
                  value: jop.id,
                };
              }),
            }}
          />
        </Col>
       
      </Row>
    </Form>
  );
};

export default PrizeFilter;
